module.exports = __webpack_public_path__ + "images/3eb5641286ca905bf9234b4a20e1d08a-sensorbox_edit33120.png";